import React from "react"
import { Fields, Form2 } from "@cd2/forms"
import { countries } from "../../constants/countries"
import { useSettings } from "../../utils/useSettings"
import { IComponentProps } from "@cd2/tools/build/es6"

export function CountrySelect(props?: {
  field?: string
  validations?: IComponentProps<typeof Form2.Select>["validations"]
  disabled?: boolean
  defaultValue?: (typeof countries)[number]["name"]
}) {
  const countryOptions = countries.map(country => ({ value: country.name, label: country.name }))
  const { defaultCountry, _loaded } = useSettings()

  if (!_loaded) {
    return <Fields.Select2 disabled />
  }
  return (
    <Form2.Select
      options={countryOptions}
      label="Country"
      field={props?.field ?? "country"}
      defaultValue={props?.defaultValue ?? defaultCountry}
      valueExtractor={(val: any) => val.value}
      validations={props?.validations}
      disabled={props?.disabled}
    />
  )
}
export function CountrySelectField(props: {
  onChange: (value?: { label: string; value: string }) => void
  value?: { label: string; value: string }
  validations?: IComponentProps<typeof Form2.Select>["validations"]
  disabled?: boolean
  defaultValue?: (typeof countries)[number]["name"]
}) {
  const countryOptions = countries.map(country => ({ value: country.name, label: country.name }))
  const { defaultCountry, _loaded } = useSettings()

  if (!_loaded) {
    return <Fields.Select2 disabled />
  }
  return (
    <Fields.Select2
      options={countryOptions}
      label="Country"
      onChange={props.onChange}
      getOptionLabel={opt => opt.label}
      getOptionValue={opt => opt.value}
      defaultValue={countryOptions.find(
        x => x.label === props?.defaultValue || x.label === defaultCountry,
      )}
      disabled={props?.disabled}
      isClearable
    />
  )
}
